import { Link } from "react-router-dom";

export default function CtaBanner() {
  return (
    <section className="relative overflow-hidden bg-background-50 py-12 md:py-16">
      <div className="mx-auto w-full px-4 md:px-6 lg:px-10">
        <div className="relative flex flex-col items-center overflow-hidden rounded-lg bg-primary-600 px-6 py-12 text-center md:py-16">
          <div className="absolute -right-10 -top-10 h-48 w-48 rounded-full bg-accent-500/20 blur-2xl" />
          <div className="absolute -bottom-12 -left-8 h-56 w-56 rounded-full bg-background-950/10 blur-2xl" />
          <div className="relative z-10 flex w-full flex-col items-center">
            <span className="flex h-12 w-12 items-center justify-center rounded-full bg-background-50/15 text-background-50">
              <i className="ri-fire-fill text-2xl" aria-hidden="true" />
            </span>
            <h2 className="mt-5 font-heading text-2xl font-black text-background-50 md:text-3xl">
              点燃死气之炎，开启你的阅读之旅
            </h2>
            <p className="mt-3 max-w-xl text-sm leading-7 text-background-50/85 md:text-base">
              《家庭教师》全集免费在线阅读，下拉式漫画体验，海量热门漫画随心看，现在就开始吧！
            </p>
            <div className="mt-7 flex flex-col gap-3 sm:flex-row">
              <Link
                to="/read/jiating-jiaoshi/ch-01"
                className="flex h-12 items-center justify-center gap-2 whitespace-nowrap rounded-md bg-background-50 px-8 text-sm font-bold text-primary-700 transition-colors hover:bg-background-100"
              >
                <i className="ri-play-fill" aria-hidden="true" />
                立即阅读《家庭教师》
              </Link>
              <Link
                to="/category/all"
                className="flex h-12 items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/40 px-8 text-sm font-bold text-background-50 transition-colors hover:bg-background-50/10"
              >
                浏览更多漫画
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}